module.exports = __webpack_public_path__ + "img/logo.4019d559.png";